import React from "react";
import DataSection from "../components/sections/Data.jsx";
import { data } from "../constants/mackolik/data.js";
import { notification } from "../constants/mackolik/push-notification.js";
import SliderSection from "../components/sections/Slider.jsx";
import { videolar } from "../constants/mackolik/videolar.js";
import { projeler } from "../constants/mackolik/projeler.js";
import { sosyalMedya } from "../constants/mackolik/sosyal-medya.js";
import { icerikler } from "../constants/mackolik/icerikler.js";
import { display } from "../constants/mackolik/display.js";
import { useLanguage } from "../contexts/LanguageContext";

export default function Mackolik() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/5e392685b7b76dc2c9b16bda15604eaf6f30846ed5778b43418890889fa9a0ba.jpeg"
            : "https://srv-cdn.onedio.com/store/d5ca26b052dc5a5ce2541170c0e34a3574fb0d2ecced9ce5871d7bc211d7e8bb.jpg"
        }
        className="w-full max-w-[1440px] mx-auto"
        alt=""
      />
      <DataSection data={data} title="Datalar" name="datalar" />
      <SliderSection
        className={"bg-[#FBFBFB]"}
        data={notification}
        circle={true}
        name="push"
      />
      <SliderSection
        className={"bg-[#F3FCF6]"}
        data={videolar}
        circle={false}
        name="videolar"
      />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="projeler"
      />
      <SliderSection
        className={"bg-[#F3FCF6]"}
        data={sosyalMedya}
        circle={false}
        name="sosyal-medya"
      />
      <SliderSection
        className={"bg-[#fdf2f0]"}
        data={icerikler}
        circle={false}
        name="icerikler"
      />
      <SliderSection
        className={"bg-[#ffefdd]"}
        data={display}
        circle={false}
        name="display"
      />
    </div>
  );
}
